import { Box } from '@mui/material'

export const Mirrors = ({ zIndex = 1 }: { zIndex?: number }) => {
  return (
    <Box
      className="mirrors"
      sx={{
        position: 'absolute',
        top: '-50%',
        height: '200%',
        width: '20%',
        transform: 'skewX(-25deg)',
        left: '-75%',
        WebkitAnimation: 'shine 3s infinite',
        animation: 'shine 3s infinite',
        zIndex: zIndex,

        '&::before, &::after': {
          top: '0',
          height: '100%',
          content: '""',
          position: 'absolute',
          backgroundColor: 'rgba(255, 255, 255, 0.3)',
        },

        '&::before': {
          width: '30%',
          left: '0',
        },

        '&::after': {
          width: '50%',
          right: '0',
        },
        '@keyframes shine': {
          '0%': {
            left: '-75%',
          },
          '50%, 80%': {
            left: '125%',
          },
          '100%': {
            left: ' 125%',
          },
        },
      }}
    />
  )
}
